import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import { publisherLabel } from '../../utils';

const StatusBadge = ({ isActive }) => {
    return (
        <span
            className={classnames('badge', {
                'badge-success': isActive,
                'badge-warning': !isActive
            })}
        >
            {isActive ? 'Active' : 'Inactive'}
        </span>
    );
};

function ResultsTable(props) {
    const searchResults = props.results;

    return (
        <>
            {searchResults && (
                <>
                    <h4>Search Results</h4>
                    <table className="table full-width mt-12">
                        <thead>
                            <tr>
                                <th>Content ID</th>
                                <th>Status</th>
                                <th>Title</th>
                                <th>Publisher</th>
                                <th>Author</th>
                                <th>Narrator</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.results.map((book) => {
                                return (
                                    <tr key={book._id}>
                                        <td>
                                            <Link to={`/title-management/${book.contentId}`}>{book.contentId}</Link>
                                        </td>
                                        <td>
                                            <StatusBadge isActive={book.active} />
                                        </td>
                                        <td className="w-64">
                                            <strong className="d-block">{book.title}</strong>
                                            <span className="txt-gray">{book.subtitle}</span>
                                        </td>
                                        <td>
                                            {publisherLabel(book.publisherName, book.publisherDisplayName)}
                                        </td>
                                        <td>{book.contributors?.authors[0]?.fullName}</td>
                                        <td>{book.contributors?.narrators[0]?.fullName}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </>
            )}
        </>
    );
}

export default ResultsTable;
